var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ara\\xF1a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Simulador---Gracias",
    transform: "translate(-640.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(640.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFD872",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,104.518 C72.674,104.518 73.444,104.188 74.06,103.528 L74.06,103.528 L112.01,65.578 C112.67,64.962 113,64.192 113,63.268 C113,62.344 112.67,61.552 112.01,60.892 L112.01,60.892 L107.39,56.272 C106.73,55.612 105.949,55.282 105.047,55.282 C104.145,55.282 103.364,55.612 102.704,56.272 L102.704,56.272 L71.75,87.226 L57.1387917,72.613875 C56.5505972,72.0592917 55.833,71.782 54.986,71.782 C54.062,71.782 53.27,72.112 52.61,72.772 L52.61,72.772 L47.99,77.392 C47.33,78.052 47,78.844 47,79.768 C47,80.692 47.33,81.462 47.99,82.078 L47.99,82.078 L69.44,103.528 C70.056,104.188 70.826,104.518 71.75,104.518 Z",
    id: "\\uE89C",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.75293301816dfab88752a4daff376603.svg";
export { ForwardRef as ReactComponent };